





















import {Component, Vue, Watch} from "vue-property-decorator";
import {userObject, userPrivateData} from '@/store/types'
import {MutationList as userMutations} from '@/store/modules/user/mutation-list'
import axios from "axios";
import {MutationList as modalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class Personal extends Vue {

    private userNamespace = 'user/';
    private modalNamespace = 'modal/';

    private user: userPrivateData = {
        name: '',
        surname: ''
    };

    get userData(): userObject {
        return this.$store.getters[this.userNamespace + 'getUserData']
    }

    created(){
        this.user.name = this.userData.name;
        this.user.surname = this.userData.surname;
    }

    async saveChanges() {
        this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_LOADING_MODAL}`, 'Saving data');

        await axios.post('http://someurl.com/save/user', this.user)
            .then(() => {
                if(this.user.name !== this.userData.name) this.$store.commit(`${this.userNamespace}${userMutations.CHANGE_USER_NAME}`, this.user.name);
                if(this.user.surname !== this.userData.surname) this.$store.commit(`${this.userNamespace}${userMutations.CHANGE_USER_SURNAME}`, this.user.surname)
                this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
                this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_SMALL_MODAL}`, {message: 'data saved', title: 'Success!!'});
            })
            .catch(e => {
                this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                    header: 'an error happened',
                    message: e
                });
            });
    }
}
